import { CommunicationSessionEventLogSendReservationOffer, UserData } from '@pwp-common';

import { CommunicationTaskName } from '../../../../../../../../common/src/objects/communication/communication-task';
import { RowCell } from '../../../../common/p-table/row-cell';
import { CommunicationSessionSendMessageLogBase } from '../base/communication-session-send-message-log-base';

export class SendReservationOfferRow extends CommunicationSessionSendMessageLogBase<CommunicationSessionEventLogSendReservationOffer> {
  //////////////////////////////////////////////////////////////////////////////////////////
  // Constructor
  //////////////////////////////////////////////////////////////////////////////////////////
  constructor({
    event,
    allDataUser,
    timezone,
  }: {
    event: CommunicationSessionEventLogSendReservationOffer;
    allDataUser: Map<string, UserData>;
    timezone: string;
  }) {
    super({
      event,
      allDataUser,
      timezone,
      userId: event.getParticipant().getParticipantId(),
      userStatus: event.getUserStatus(),
    });
    this.updateOriginationReason(event);
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  // Origination Reason
  //////////////////////////////////////////////////////////////////////////////////////////
  private updateOriginationReason(event: CommunicationSessionEventLogSendReservationOffer) {
    const translationKeys = {
      [CommunicationTaskName.callbackRequest]: 'cellOriginationReasonSendCallbackRequest',
      [CommunicationTaskName.conversationRequest]: 'cellOriginationReasonSendConversationRequest',
    };

    const translationKey = translationKeys[event.getCommunicationTaskType()];

    if (translationKey) {
      this.originationReason = new RowCell<string>({
        translationScope: 'communication-session-event-row',
        translationKey,
        translationObj: {
          ...this.userDisplayNameWithEmail.translationObj,
        },
        sortValue: translationKey,
        styleClass: undefined,
      });
    }
  }
}
